'use es6';

export var MINIMUM_REVIEWS_REQUIRED_TO_DISPLAY = 3;